import {
  Org,
  PlatformPreferenceData,
  PlatformUser,
  SaaSPreferenceData,
  SaaSUser,
  Supplier,
  SupplierStatusFlags
} from '@scaleup/models';
import { isNil } from 'lodash';
import { useGetOrgQuery, useGetUserQuery, useUpdateSupplierStatusFlagsMutation, useUpdateUserPreferencesMutation } from '../api';



export type UseSupplierStatusFlags = {
  flag: boolean;
  updateSupplierStatusFlag: (val: boolean) => Promise<void>;
  updateLoading: boolean;
  flagLoading: boolean;
  supplier?: Org;
};

export const useSupplierStatusFlags = (
  pref: keyof SupplierStatusFlags,
  defaultValue: boolean
): UseSupplierStatusFlags => {
  const { data: supplier, isLoading: flagLoading } = useGetOrgQuery();

  const [updateSupplierStatusFlag_, { isLoading: updateLoading }] =
    useUpdateSupplierStatusFlagsMutation();

  const updateSupplierStatusFlag = async (val: boolean) => {
    const prefs = { ...((supplier as Supplier)?.statusFlags || {}) }; // creating a new object by spreading
    // @ts-ignore
    prefs[pref] = val;
    await updateSupplierStatusFlag_(prefs);
  };

  const getFlags = () => {
    if (!supplier) {
      return defaultValue;
    }

    const prefs = (supplier as Supplier).statusFlags || {};

    // @ts-ignore
    const value = prefs[pref];

    return isNil(value) ? defaultValue : value;
  };

  return {
    flag: getFlags(),
    updateSupplierStatusFlag,
    updateLoading,
    flagLoading,
    supplier,
  };
};
